import React from "react";
import styled from "styled-components";

import { colorFromTheme, hsl } from "@examspark/common-ui/server";
import { RubricDocument as RubricType } from "@examspark/types";

import PrintUnitContent from "./PrintUnitContent";

type RubricEditorProps = {
  data: RubricType;
};

const RubricTable = styled.table`
  &,
  & th,
  & td {
    font-size: 1.3rem;
    font-style: normal;
    font-weight: normal;
  }
  & {
    border: 1px solid black;
  }
  & th,
  & td {
    padding: 0 0.1in;
    min-width: 1in;
    border: 1px solid #999;
  }
`;

const SectionHeader = styled.tr`
  background-color: ${colorFromTheme("surface5")};
  & td {
    margin: 0.1in;
    padding: 0.1in;
  }
`;

const GutterHeader = styled.td`
  background-color: ${(props) => hsl(props.theme.colors?.surface3.color, 0.7)};
`;

const UnitHeader = styled.td`
  background-color: ${(props) => hsl(props.theme.colors?.surface3.color, 0.7)};
`;

const Rubric = ({ data }: RubricEditorProps) => {
  if (!data.headers) return null;
  if (!data.sections) return null;

  return (
    <RubricTable>
      <thead>
        <tr>
          <GutterHeader />
          {data.headers.map((header, columnIndex) => (
            <th key={columnIndex}>
              <PrintUnitContent content={header.value} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.sections.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            <SectionHeader>
              <td colSpan={data.headers.length + 1}>
                <PrintUnitContent content={section.sectionLabel} />
              </td>
            </SectionHeader>
            {section.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <UnitHeader>
                  <PrintUnitContent content={row.criteriaLabel} />
                </UnitHeader>
                {row.cellData.map((cell, cellIndex) => (
                  <td key={cellIndex}>
                    <PrintUnitContent content={cell.value} />
                  </td>
                ))}
              </tr>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </RubricTable>
  );
};

export default Rubric;
